import React, { useState, useRef, useEffect } from "react";

const faq = [
  {
    question: "¿Qué servicios ofrecen?",
    answer: "Ofrecemos mudanzas locales, nacionales e internacionales, embalaje, almacenamiento, mudanza de oficinas, transporte de objetos delicados y servicio de guardamuebles.",
    keywords: ["servicio", "servicios", "ofrecen", "oferta", "mudanza", "mudanzas", "embalaje", "guardamuebles", "almacenamiento", "oficinas", "objetos delicados"]
  },
  {
    question: "¿Cómo solicito una cotización?",
    answer: "Puedes solicitar una cotización completando el formulario de contacto en nuestra web, llamando al número publicado o escribiéndonos por WhatsApp.",
    keywords: ["cotización", "presupuesto", "precio", "cuánto", "coste", "costar", "solicitar", "pedir"]
  },
  {
    question: "¿Cuánto cuesta una mudanza?",
    answer: "El costo depende del volumen, la distancia, los servicios adicionales y la fecha. Solicita una cotización personalizada para obtener un precio exacto.",
    keywords: ["cuánto", "precio", "coste", "costar", "tarifa", "valor", "mudanza", "precios"]
  },
  {
    question: "¿Realizan mudanzas internacionales?",
    answer: "Sí, realizamos mudanzas internacionales. Contáctanos para asesorarte sobre los requisitos y el proceso.",
    keywords: ["internacional", "internacionales", "extranjero", "fuera del país", "mudanza internacional"]
  },
  {
    question: "¿Qué zonas cubren?",
    answer: "Realizamos mudanzas en todo el país y también internacionales. Consulta tu zona específica para confirmación.",
    keywords: ["zona", "zonas", "cobertura", "dónde", "área", "región", "ciudad", "país"]
  },
  {
    question: "¿Cuánto tiempo tarda una mudanza?",
    answer: "El tiempo depende de la distancia y el volumen. Las mudanzas locales suelen completarse en el día; las nacionales o internacionales pueden tardar más.",
    keywords: ["tiempo", "tarda", "demora", "duración", "cuánto tarda", "cuánto tiempo"]
  },
  {
    question: "¿Ofrecen servicio de embalaje?",
    answer: "Sí, contamos con servicio profesional de embalaje para proteger tus pertenencias durante la mudanza.",
    keywords: ["embalaje", "empaquetado", "empaquetar", "proteger", "cajas", "envolver"]
  },
  {
    question: "¿Puedo embalar mis cosas por mi cuenta?",
    answer: "Sí, puedes embalar tus pertenencias. Si lo prefieres, nuestro equipo puede encargarse del embalaje profesional.",
    keywords: ["embalar", "empaquetar", "yo mismo", "por mi cuenta", "puedo embalar"]
  },
  {
    question: "¿Qué objetos no se pueden transportar?",
    answer: "No transportamos materiales peligrosos, inflamables, armas, animales vivos ni objetos prohibidos por la ley.",
    keywords: ["no se pueden", "prohibido", "no transportan", "materiales peligrosos", "inflamables", "armas", "animales", "prohibidos"]
  },
  {
    question: "¿Transportan objetos delicados o de gran valor?",
    answer: "Sí, tenemos experiencia en el traslado de pianos, obras de arte, antigüedades y objetos delicados. Avísanos para tomar precauciones especiales.",
    keywords: ["delicado", "delicados", "valor", "gran valor", "piano", "obras de arte", "antigüedades", "especiales"]
  },
  {
    question: "¿Ofrecen seguro para la mudanza?",
    answer: "Sí, ofrecemos seguro para tus pertenencias durante la mudanza. Consulta las opciones y coberturas disponibles.",
    keywords: ["seguro", "asegurar", "cobertura", "protección", "daños", "póliza"]
  },
  {
    question: "¿Cómo puedo pagar el servicio?",
    answer: "Aceptamos pagos en efectivo, transferencia bancaria y tarjetas. Consulta por otras opciones si lo necesitas.",
    keywords: ["pago", "pagar", "formas de pago", "tarjeta", "efectivo", "transferencia", "cómo pagar"]
  },
  {
    question: "¿Con cuánta anticipación debo reservar mi mudanza?",
    answer: "Recomendamos reservar con al menos una semana de anticipación, especialmente en temporada alta.",
    keywords: ["anticipación", "reservar", "cuándo reservar", "con cuánto", "tiempo antes"]
  },
  {
    question: "¿Puedo cambiar la fecha de mi mudanza?",
    answer: "Sí, puedes reprogramar tu mudanza avisando con anticipación. Contáctanos para coordinar el cambio.",
    keywords: ["cambiar fecha", "reprogramar", "modificar", "cambio de fecha"]
  },
  {
    question: "¿Qué hago si necesito guardar mis cosas por un tiempo?",
    answer: "Ofrecemos servicio de guardamuebles y almacenamiento seguro por el tiempo que necesites.",
    keywords: ["guardar", "almacenar", "guardamuebles", "depósito", "almacenamiento"]
  },
  {
    question: "¿Cómo contacto con atención al cliente?",
    answer: "Puedes contactarnos por teléfono, WhatsApp, correo electrónico o a través del formulario de contacto en nuestra web.",
    keywords: ["contacto", "atención", "cliente", "teléfono", "correo", "email", "whatsapp"]
  },
  {
    question: "¿Trabajan los fines de semana y feriados?",
    answer: "Sí, realizamos mudanzas los fines de semana y feriados. Consulta disponibilidad para tu fecha.",
    keywords: ["fines de semana", "sábados", "domingos", "feriados", "trabajan"]
  },
  {
    question: "¿Qué pasa si algo se daña durante la mudanza?",
    answer: "Contamos con seguro y tomamos todas las precauciones. Si ocurre algún daño, te asistiremos para resolverlo.",
    keywords: ["daño", "daños", "rompe", "romper", "estropea", "estropear", "seguro"]
  },
  {
    question: "¿Cuántas personas forman el equipo de mudanza?",
    answer: "El equipo se ajusta al tamaño de la mudanza, normalmente entre 2 y 6 personas capacitadas.",
    keywords: ["equipo", "personas", "cuántos", "personal", "trabajadores"]
  },
  {
    question: "¿Puedo acompañar el camión durante la mudanza?",
    answer: "Por razones de seguridad y seguro, no es posible acompañar al camión. Puedes seguir el traslado y estar en destino para la descarga.",
    keywords: ["acompañar", "camión", "ir en el camión", "viajar", "acompañante"]
  },
  {
    question: "¿Qué vehículos utilizan para las mudanzas?",
    answer: "Contamos con camiones y furgones de diferentes tamaños, adaptados a cada tipo de mudanza.",
    keywords: ["vehículos", "camiones", "furgones", "transporte", "camión"]
  },
  {
    question: "¿Qué debo hacer antes del día de la mudanza?",
    answer: "Te recomendamos separar objetos personales, vaciar electrodomésticos, etiquetar cajas y coordinar accesos en origen y destino.",
    keywords: ["antes", "preparar", "previo", "día de la mudanza", "recomendaciones"]
  },
  {
    question: "¿Puedo cancelar mi mudanza?",
    answer: "Sí, puedes cancelar avisando con anticipación. Consulta nuestras políticas de cancelación.",
    keywords: ["cancelar", "anular", "suspender", "cancelación"]
  },
  {
    question: "¿Realizan mudanzas de oficinas o empresas?",
    answer: "Sí, tenemos experiencia en mudanzas corporativas y de oficinas. Solicita asesoramiento personalizado.",
    keywords: ["oficinas", "empresa", "corporativa", "negocio", "mudanza de oficina"]
  },
  {
    question: "¿Qué medidas de seguridad toman durante la mudanza?",
    answer: "Nuestro equipo está capacitado y utiliza materiales de protección y técnicas seguras para el traslado de tus pertenencias.",
    keywords: ["seguridad", "medidas", "proteger", "protección", "seguro"]
  }
];

function getBotResponse(userMessage) {
  const msg = userMessage.toLowerCase();
  // Buscar coincidencia por palabra clave
  for (let item of faq) {
    if (item.keywords.some(keyword => msg.includes(keyword))) {
      return item.answer;
    }
  }
  // Si no hay coincidencia, buscar por pregunta exacta
  for (let item of faq) {
    if (msg.includes(item.question.toLowerCase())) {
      return item.answer;
    }
  }
  // Respuesta por defecto
  return "Lo siento, no entiendo tu pregunta. ¿Puedes reformularla o consultar nuestras preguntas frecuentes?";
}

const Chatbot = ({ onClose }) => {
  const [messages, setMessages] = useState([
    { from: "bot", text: "¡Hola! Soy el asistente virtual de Frabas. ¿En qué puedo ayudarte?" }
  ]);
  const [input, setInput] = useState("");
  const chatEndRef = useRef(null);

  useEffect(() => {
    chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  const handleSend = () => {
    if (!input.trim()) return;
    const userMsg = { from: "user", text: input };
    const botMsg = { from: "bot", text: getBotResponse(input) };
    setMessages((msgs) => [...msgs, userMsg, botMsg]);
    setInput("");
  };

  const mainRed = "#d32f2f";

  return (
    <div style={{
      width: 340,
      background: "#fff",
      border: `1.5px solid ${mainRed}`,
      borderRadius: 16,
      boxShadow: `0 8px 32px ${mainRed}22, 0 1.5px 4px rgba(0,0,0,0.08)`,
      fontFamily: "inherit"
    }}>
      <div style={{
        background: mainRed,
        color: "#fff",
        padding: "14px 18px",
        borderTopLeftRadius: 16,
        borderTopRightRadius: 16,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        fontWeight: 600,
        fontSize: 18,
        letterSpacing: 0.5,
        boxShadow: `0 2px 8px ${mainRed}22`
      }}>
        <span style={{ color: "#fff", textShadow: "0 1px 2px #b71c1c" }}>
          Chatbot Frabas
        </span>
        <button
          onClick={onClose}
          style={{
            background: "transparent",
            border: "none",
            color: "#fff",
            fontSize: 22,
            cursor: "pointer",
            marginLeft: 8,
            fontWeight: 700,
            lineHeight: 1
          }}
          aria-label="Cerrar chatbot"
        >
          ×
        </button>
      </div>
      <div style={{
        maxHeight: 500,
        minHeight: 350,
        overflowY: "auto",
        padding: "18px 12px 8px 12px",
        background: "#fff"
      }}>
        {messages.map((msg, i) => (
          <div
            key={i}
            style={{
              display: "flex",
              justifyContent: msg.from === "bot" ? "flex-start" : "flex-end",
              alignItems: "flex-end",
              margin: "8px 0"
            }}
          >
            {msg.from === "bot" && (
              <img
                src="/logo.png"
                alt="Logo Frabas"
                style={{
                  width: 28,
                  height: 28,
                  borderRadius: "50%",
                  marginRight: 8,
                  border: `1.5px solid ${mainRed}`,
                  background: "#fff",
                  objectFit: "cover"
                }}
              />
            )}
            <span style={{
              display: "inline-block",
              background: msg.from === "bot" ? "#fff" : mainRed,
              color: msg.from === "bot" ? "#222" : "#fff",
              borderRadius: msg.from === "bot" ? "12px 12px 12px 4px" : "12px 12px 4px 12px",
              padding: "8px 14px",
              maxWidth: "80%",
              fontSize: 15,
              boxShadow: msg.from === "bot"
                ? `0 1px 4px ${mainRed}11`
                : `0 1px 4px ${mainRed}33`
            }}>
              {msg.text}
            </span>
          </div>
        ))}
        <div ref={chatEndRef} />
      </div>
      <div style={{
        display: "flex",
        borderTop: "1px solid #e3e3e3",
        background: "#fff",
        borderBottomLeftRadius: 16,
        borderBottomRightRadius: 16,
        padding: "8px 10px"
      }}>
        <input
          style={{
            flex: 1,
            border: "none",
            padding: "10px 12px",
            borderRadius: 8,
            background: "#f1f3f6",
            fontSize: 15,
            outline: "none",
            marginRight: 8
          }}
          type="text"
          placeholder="Escribe tu mensaje..."
          value={input}
          onChange={e => setInput(e.target.value)}
          onKeyDown={e => e.key === "Enter" && handleSend()}
        />
        <button
          style={{
            border: "none",
            background: mainRed,
            color: "#fff",
            borderRadius: 8,
            padding: "0 18px",
            cursor: "pointer",
            fontWeight: 600,
            fontSize: 16,
            display: "flex",
            alignItems: "center",
            transition: "background 0.2s"
          }}
          onClick={handleSend}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="none"
            viewBox="0 0 24 24"
            style={{ marginRight: 4 }}
          >
            <path
              fill="currentColor"
              d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"
            />
          </svg>
          Enviar
        </button>
      </div>
    </div>
  );
};

export default Chatbot;